import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDownloadNote = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.83301 15.8385H17.833V17.5052H2.83301V15.8385ZM11.1663 10.9815L16.2256 5.92229L17.4041 7.10081L10.333 14.1719L3.26194 7.10081L4.44045 5.92229L9.49967 10.9815V1.67188H11.1663V10.9815Z",
		fill: "#03314B"
	})
});
export default SvgIconDownloadNote;
